module.exports = "/_next/static/images/error-02-aeff01c0058c3523004382df23928d04.svg";